import { render, staticRenderFns } from "./activityResult.vue?vue&type=template&id=b4d8d606&scoped=true"
import script from "./activityResult.vue?vue&type=script&lang=js"
export * from "./activityResult.vue?vue&type=script&lang=js"
import style0 from "./activityResult.vue?vue&type=style&index=0&id=b4d8d606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d8d606",
  null
  
)

export default component.exports